"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorEnvelopeSchema = exports.errorDetailSchema = void 0;
const zod_1 = require("zod");
/**
 * The error envelope. **Every non-2xx response has exactly this shape and nothing else.**
 *
 * Clients branch on `code`, never on `message` — the code is stable and machine-readable,
 * the message is for a person and will be reworded. `request_id` is generated per request,
 * returned as a header, written to the logs and to the audit row, so a support
 * conversation can start from one string.
 *
 * ⚠️ The code catalogue is deliberately NOT here yet. It arrives with the first endpoint
 * that can refuse something (C4), because a catalogue written before its call sites is a
 * list of guesses — and `CLAUDE.md` §2.8 forbids inventing codes ahead of need. What is
 * here is the SHAPE, which every later chunk inherits.
 */
exports.errorDetailSchema = zod_1.z.object({
    /** JSON path of the offending field, where the error is about one. */
    field: zod_1.z.string().optional(),
    /** Stable, `snake_case`. A client may branch on this too. */
    code: zod_1.z.string(),
    /** Safe to display. */
    message: zod_1.z.string(),
});
exports.errorEnvelopeSchema = zod_1.z.object({
    error: zod_1.z.object({
        code: zod_1.z.string(),
        message: zod_1.z.string(),
        details: zod_1.z.array(exports.errorDetailSchema).optional(),
        request_id: zod_1.z.string(),
    }),
});
//# sourceMappingURL=errors.js.map